import React from 'react';
import Link from 'components/core/link';

import { ConditionalWrapper } from 'shared/components/conditional-wrapper';

type ConditionalLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  children: React.ReactNode;
  url: string | null;
};

export const ConditionalLink = ({ url, children, ...anchorProps }: ConditionalLinkProps): JSX.Element => (
  <ConditionalWrapper
    condition={!!url}
    wrapper={(wrapperChildren) => (
      // BetterLink detects anchor children itself (legacyBehavior + passHref) and
      // injects an <a> with the forwarded attrs otherwise, so no branching needed here.
      <Link href={url ?? ''} {...anchorProps}>
        {wrapperChildren}
      </Link>
    )}
  >
    {children}
  </ConditionalWrapper>
);
